<script setup lang="ts">
definePageMeta({
	name: 'error-404',
});

const err = useError().value;
</script>

<template>
	<NuxtLayout name="entry" v-if="err?.statusCode === 404">
		<HmEntryRoot>
			<template #header>
				<HmEntryContent title="Page not found!" description="The page may have been moved, or the URL has expired and is no longer accessible." />
			</template>

			<div class="form-container form-container--entry">
				<div class="form-actions">
					<HmButton
						label="Return to Log In"
						:to="{ name: 'login' }"
						variant="solid"
						size="lg"
						is-wide
					/>
				</div>
			</div>
		</HmEntryRoot>
	</NuxtLayout>
</template>
